export default {
  filterDefaults: {
    replace: "ALL",
    high_dk: null,
    name: "",
    type: "ALL",
  },
  MAIN_COMPANIES: [1, 2, 4, 8], // todo - don't hard code this . . .
  replaceKeyForDays: {
    1: "DAILIES",
    7: "WEEKLY",
    14: "2WEEK",
    30: "MONTHLY",
    90: "QUARTERLY",
    365: "YEARLY",
  },
  filterOptions: {
    type: {
      ALL: {
        label: "All Types",
        title: "All Types",
        image: "all_types",
        toric: null,
        bifocal: null,
        cosmetic: null,
      },
      SPHERE: {
        label: "Spheres",
        title: "Spheres",
        image: "sphere",
        toric: 0,
        bifocal: 0,
        cosmetic: 0,
      },
      TORIC: {
        label: "Torics",
        title: "Torics",
        image: "toric",
        toric: 1,
        bifocal: 0,
        cosmetic: 0,
      },
      BIFOCAL_SPHERE: {
        label: "Multifocals",
        title: "Multifocals",
        image: "bifocal_sphere",
        toric: 0,
        bifocal: 1,
        cosmetic: 0,
      },
      BIFOCAL_TORIC: {
        label: "Toric Multifocals",
        title: "Toric Multifocals",
        image: "bifocal_toric",
        toric: 1,
        bifocal: 1,
        cosmetic: 0,
      },
      COSMETIC_SPHERE: {
        label: "Cosmetics",
        image: "cosmetic_sphere",
        toric: 0,
        bifocal: 0,
        cosmetic: 1,
      },
      COSMETIC_TORIC: {
        label: "Toric Cosmetics",
        title: "Toric Cosmetics",
        image: "cosmetic_toric",
        toric: 1,
        bifocal: 0,
        cosmetic: 1,
      },
    },
    replace: {
      ALL: {
        label: "Any Replacement",
        shortText: "Any",
        image: "replace_all",
        days: null,
      },
      DAILIES: {
        label: "Daily Replacement",
        shortText: "Daily",
        title: "Daily Replacement",
        image: "replace_1",
        days: [1],
      },
      WEEKLY: {
        label: "1 Week Replacement",
        shortText: "Weekly",
        title: "Weekly Replacement",
        image: "replace_7",
        days: [7],
      },
      "2WEEK": {
        label: "2 Week Replacement",
        shortText: "2 Weeks",
        title: "2 Week Replacement",
        image: "replace_14",
        days: [14],
      },
      MONTHLY: {
        label: "Monthly Replacement",
        shortText: "Monthly",
        title: "Monthly Replacement",
        image: "replace_30",
        days: [30],
      },
      DISPOSABLES: {
        label: "All Disposables",
        shortText: "Disposables",
        longText: "daily, weekly, 2 week, monthly",
        image: "replace_all",
        days: [1, 7, 14, 30],
      },
      QUARTERLY: {
        label: "Quarterly Replacement",
        shortText: "Quarterly",
        title: "Quarterly Replacement",
        image: "replace_90",
        days: [90],
      },
      YEARLY: {
        label: "Yearly Replacement",
        shortText: "Yearly",
        title: "Yearly Replacement",
        image: "replace_365",
        days: [365],
      },
    },
  },

  // returns one of the filterOptions:type objects above
  // eg) ("type", "TORIC") returns {label: "Torics", image: "toric", toric: 1, . . .}
  objectForFilterOption(filterName, filterKey) {
    if (!filterKey || !filterName) return null;
    let key = filterKey.toUpperCase();
    if (!this.filterOptions[filterName]) return null;
    if (!this.filterOptions[filterName][key]) return null;
    return this.filterOptions[filterName][key];
  },

  // a convenience function to get the value of filterOptions:type parameter (parameter: toric|bifocal|cosmetic) for a given typeKey (SPHERE|TORIC|etc)
  // returns value of (toric/bifocal/cosmetic): 1 or 0 (or null)
  parameterValueForLensType(typeKey, parameter) {
    typeKey = typeKey.toString().toUpperCase();
    let typeItem = this.objectForFilterOption("type", typeKey);
    if (!Object.prototype.hasOwnProperty.call(typeItem, parameter)) return null;
    return typeItem[parameter];
  },

  // takes a filterOptions.replace key ("ALL", "DAILIES", "2WEEK", etc)
  // returns the "days" field for that object, eg) null, [1],[14] . . .
  daysArrayForReplacementKey(key) {
    let obj = this.objectForFilterOption("replace", key);
    if (!obj) return null;
    return obj.days;
  },

  // returns the title property for a given filter name (eg "type" or "replace") and filterKey (eg "TORIC" or "DAILIES"  )
  titleForOptionKey(filterName, filterKey) {
    let rtn = null;
    let obj = this.objectForFilterOption(filterName, filterKey);
    if (obj && obj.title) rtn = obj.title;
    return rtn;
  },
  // the company filter will be "ALL", "MAIN", or a company ID (eg 4)
  // for main will return ids of the big 4 companies [1,2,4,8]
  // for all will return null (do not want to filter).
  // if it's an integer will return that id as an array
  arrayForCompanyFilter(val) {
    let arr = this.MAIN_COMPANIES;
    val = val.toUpperCase();
    if (val == "ALL") arr = null;
    if (val == "MAIN") arr = [1, 2, 4, 8];
    if (val == "FAVORITES") arr = [1, 2, 4, 8]; // todo get/store favs in store
    if (parseInt(val) > 0) arr = [parseInt(val)];
    return arr;
  },
  // returns an image file name for a type key (eg "SPHERE" or "BIFOCAL_TORIC")
  // note: does not include the path
  // todo - add the image path here too
  imageForType(typeKey, active = true) {
    let file = this.parameterValueForLensType(typeKey, "image");
    if (!file) return null;
    let url = file + "_icon";
    if (active) url += "_active.svg";
    return url;
  },
  replaceTitleForDays(days) {
    let rtn = null;
    let key = this.replaceKeyForDays[days];
    if (key) rtn = this.filterOptions.replace[key]?.title;
    return rtn;
  },
};
